import React from 'react';

function Hierarchy({ size, stroke, strokeWidth, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path fill="none" d="M-1-1h26v26H-1z" />
      <g fillRule="evenodd" fill="none" stroke="none">
        <path d="M.062 0h24v24h-24z" />
        <g stroke={stroke} strokeWidth={strokeWidth}>
          <rect rx="1" height="4" width="16" y="10" x="4.062" />
          <rect rx="1" height="4" width="16" y="3" x="4.062" />
          <rect rx="1" height="4" width="11" y="17" x="9.062" />
          <path strokeLinecap="square" d="M6.062 14.5V18M6.062 19h2.5" />
        </g>
      </g>
    </svg>
  );
}

export default Hierarchy;
